import { cn, cx } from "@utils/tw"
import { ComponentProps, useEffect, useRef } from "react"

type Props = {
  active: boolean
} & Omit<ComponentProps<"span">, "children" | "active">

const STROKE = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.777 6.31214C10.7 5.50332 8.91722 5.01753 6.92993 6.23653ZM11.1765 7.11178C10.3789 6.51275 9.04102 6.11473 7.4528 7.08894C6.48072 7.68522 5.81536 9.01807 6.045 10.7303C6.27332 12.4327 7.39809 14.5104 10.0236 16.4537C11.0783 17.2344 11.4633 17.5 12.1664 17.5C12.8695 17.5 13.2545 17.2344 14.3093 16.4537C16.9347 14.5104 18.0595 12.4327 18.2878 10.7303C18.5174 9.01807 17.8521 7.68522 16.88 7.08894C15.2918 6.11472 13.9539 6.51275 13.1563 7.11178L13.1418 7.12263C12.9617 7.25785 12.8071 7.374 12.6833 7.45501C12.619 7.49715 12.5477 7.54007 12.4737 7.5735C12.4035 7.60523 12.2956 7.64492 12.1664 7.64492C12.0372 7.64492 11.9293 7.60523 11.8591 7.5735C11.7851 7.54007 11.7139 7.49715 11.6495 7.45501C11.5257 7.374 11.3711 7.25785 11.191 7.12263L11.1765 7.11178ZM12.5558 6.31214C13.6328 5.50332 15.4156 5.01753 17.4029 6.23652C18.777 7.07944 19.5503 8.84017 19.2789 10.8632C19.0063 12.896 17.6906 15.1951 14.9042 17.2575C14.8809 17.2747 14.8578 17.2918 14.8348 17.3088C13.8672 18.0254 13.2264 18.5 12.1664 18.5C11.1064 18.5 10.4656 18.0254 9.49802 17.3088C9.47508 17.2918 9.45195 17.2747 9.42863 17.2575C6.64223 15.1951 5.3265 12.896 5.05387 10.8632C4.78255 8.84017 5.55577 7.07944 6.92993 6.23653M12.5558 6.31214C12.3786 6.4452 12.2569 6.53628 12.1664 6.59778C12.0759 6.53628 11.9542 6.4452 11.777 6.31214"
    fill="currentcolor"
  />
)
const FILLED = (
  <path
    d="M17.4177 6.24033C18.7767 7.07393 19.5499 8.82148 19.2788 10.8424C19.0067 12.8718 17.6915 15.178 14.8887 17.2525L14.8266 17.2986C13.8422 18.0275 13.213 18.4934 12.1663 18.4934C11.1197 18.4934 10.4905 18.0275 9.50614 17.2986L9.44396 17.2525C6.64116 15.178 5.32599 12.8718 5.05381 10.8424C4.78277 8.82148 5.55598 7.07392 6.91494 6.24033C8.89342 5.02674 10.662 5.51109 11.7297 6.3129C11.929 6.46254 12.0612 6.56151 12.1579 6.62487L12.1663 6.63032L12.1747 6.62487C12.2715 6.56151 12.4036 6.46255 12.6029 6.31292C13.6706 5.5111 15.4392 5.02673 17.4177 6.24033Z"
    fill="currentcolor"
  />
)

export function IconWishlistAnimated({ active, ...props }: Props) {
  const ref = useRef<SVGSVGElement>(null)

  useEffect(() => {
    if (active) {
      ref.current?.animate([{ transform: "scale(1)" }, { transform: "scale(1.5)" }, { transform: "scale(1)" }], {
        duration: 300,
        easing: "ease-in-out",
        iterations: 1,
      })
    }
  }, [active])

  return (
    <span data-part="icon" {...props} className={cn("relative", props.className)}>
      <div

      // variants={{ active: { scale: 1.1 }, inactive: { scale: 0.9 } }}
      // animate={active ? "active" : "inactive"}
      // transition={{ type: "spring", stiffness: 180, damping: 8 }}
      >
        <svg ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g className={cx("transition-opacity", active ? "opacity-100" : "opacity-0")}>{FILLED}</g>
          <g>{STROKE}</g>
        </svg>
      </div>
    </span>
  )
}
